// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a:hover{cursor:pointer}.chart-section{background-color:var(--user-chart-section-background-color);border-radius:4px;padding:15px}.chart-section-heatmap{background-color:var(--user-chart-section-heatmap-background-color);border-radius:4px;padding:0px;margin-top:15px}.chart-title{font-size:1.1rem;font-weight:500;color:var(--user-chart-title-color)}", ""]);
// Exports
module.exports = exports;
